module.exports = __webpack_public_path__ + "img/Loan.505cc145.svg";